import WidgetMetricDisplay from "@/components/common/WidgetMetricDisplay";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Timer } from "lucide-react";
import React from "react";

interface AverageSpeedOfAnswerWidgetData {
  id: string;
  value: number;
  comparisonPercentage: number;
}

const AverageSpeedOfAnswerWidget: React.FC<{ data: AverageSpeedOfAnswerWidgetData; icon?: React.ReactNode; loading?: boolean; error?: string }> = ({ data, loading }) => (
  <div className="w-full min-w-[200px] rounded-lg border flex flex-col bg-white dark:bg-[#0C3451] dark:text-white dark:border-[#0C3451] p-3">
    <div className="flex flex-row items-center justify-between">
      <div className="text-[14px] font-[500] text-primary dark:text-white truncate">Average Speed Of Answer</div>
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="cursor-pointer">
              <Timer className="h-4 w-4 text-primary dark:text-white" />
            </span>
          </TooltipTrigger>
          <TooltipContent side="top">
            <p className="max-w-xs text-xs">
              The average amount of time it takes for a call to be handled by the agents within a given time.
            </p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
    {/* <div>
      {loading ? (
        <Skeleton className="h-16 w-full" />
      ) : (
        <>
          <div className="text-[24px] font-[700] text-primary dark:text-white my-3">
            {data.value ? formatSeconds(data.value) : "00:00:00"}
          </div>
          <div className="text-[12px] font-[500]">
            {data.comparisonPercentage !== undefined && data.comparisonPercentage !== null ? (
              <span
                className={
                  Number(data.comparisonPercentage.toFixed(2)) > 0
                    ? "text-green-600"
                    : Number(data.comparisonPercentage.toFixed(2)) < 0
                      ? "text-red-600"
                      : "text-primary dark:text-white"
                }
              >
                {Number(data.comparisonPercentage.toFixed(2)) !== 0
                  ? `${data.comparisonPercentage > 0 ? "+" : ""}${data.comparisonPercentage.toFixed(2)}%`
                  : "0%"}
              </span>
            ) : (
              <span className="text-primary dark:text-white">0%</span>
            )}
            {" vs previous period"}
          </div>
        </>
      )}
    </div> */}
    <div>
      <WidgetMetricDisplay
        value={data.value}
        comparisonPercentage={data.comparisonPercentage}
        loading={loading}
        format="datetime"
      />
    </div>
  </div>
);

export default AverageSpeedOfAnswerWidget;
